import React from 'react';

interface CustomImageProps {
  src?: string;
  alt?: string;
  title?: string;
}

// Function to parse image size syntax from src: ![alt](url =600x600)
function parseImageWithSize(src: string): { url: string; width?: number; height?: number } {
  const parts = src.split('#');
  
  // If there's no fragment, there are no dimensions to parse.
  if (parts.length < 2) {
    return { url: src };
  }

  const lastPart = parts[parts.length - 1];
  // A simple regex to check if a string looks like a dimension (e.g., "600x400", "300", "x200")
  const dimensionPattern = /^[0-9]*x?[0-9]*$/;

  if (dimensionPattern.test(lastPart)) {
    // The last fragment looks like a dimension, so we'll use it.
    const dimensions = lastPart;
    // Re-join the earlier parts of the URL in case the original URL had a fragment.
    const url = parts.slice(0, -1).join('#');
    
    let width: number | undefined;
    let height: number | undefined;

    if (dimensions.includes('x')) {
      const [w, h] = dimensions.split('x');
      width = w ? parseInt(w, 10) : undefined;
      height = h ? parseInt(h, 10) : undefined;
    } else {
      width = parseInt(dimensions, 10) || undefined;
    }
    
    return { url, width, height };

  } else {
    // The last fragment does not look like a dimension, so we assume it's part of the original URL.
    return { url: src };
  }
}

export function CustomImage({ src, alt, title }: CustomImageProps) {
  if (!src) return null;
  
  const { url, width, height } = parseImageWithSize(src);
  
  // Build style object for dimensions
  const style: React.CSSProperties = {};
  if (width) style.width = `${width}px`;
  if (height) style.height = `${height}px`;
  
  return (
    <img
      src={url}
      alt={alt || ''}
      title={title}
      style={Object.keys(style).length > 0 ? style : undefined}
      className="max-w-full h-auto rounded-md"
    />
  );
}
